module.exports = __webpack_public_path__ + "static/media/dem_env_ris_ass.a8962c77.png";